import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import TableAsset from './tableasset';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
// import PusherClient from '../../lib/pusher';
import AssetConfig from '../../components/assetconfig';
import AssetOrder from '../../components/assetorder';
import '../../components/balancestyle.scss';
import moment from 'moment';

import WindowMessage from '../../components/windowmessage';

import CustodianAlert from '../../components/custodianalert';

import {
  fetchBalance,
  fetchSecurity,
  fetchApprovals,
} from '../../actions';

const dateFormat = 'L LT';

class Wallets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalComponent: null,
      sideBar: null,
      darkModal: null,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.updateDataLooped = this.updateDataLooped.bind(this);
    this.showCrypto = this.showCrypto.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchBalance({ fx: true }));
    dispatch(fetchSecurity());
    dispatch(fetchApprovals());

    this.dataLoopInterval = setInterval(this.updateDataLooped, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.dataLoopInterval);
  }

  updateDataLooped() {
    const { dispatch } = this.props;
    dispatch(fetchBalance({ fx: true }));
  }

  toggleModal(component, sideBar, darkModal) {
    this.setState({
      modalComponent: component,
      sideBar,
      darkModal,
    });
  }

  showCrypto(asset) {
    const { assets } = this.props;
    let assetData;
    if (assets && assets.length) {
      assetData = assets.find((item) => {
        return item.handle === asset;
      });
    }
    let send;
    let receive;
    if (assetData && assetData.defaults) {
      send = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'SEND'));
      receive = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'RECV'));
    }
    let assetConf;
    if (AssetConfig && AssetConfig.length) {
      assetConf = AssetConfig.find((item) => item.handle === asset.toUpperCase());
    }
    let assetEnabled;
    if (assetConf && assetConf.enabled) {
      assetEnabled = assetConf.enabled;
    }
    if (assetEnabled && (send || receive)) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const { balance, user, errors, assets, tempAnon, approvals } = this.props;
    const { darkModal, sideBar } = this.state;

    // OTP Enabled
    let otpEnabled;
    let yubiEnabled;
    let withEnabled;
    let depEnabled;

    if (user && user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
    }

    // User Verified
    const userVerified = user && user.me && user.me.flags && user.me.flags.verified;
    let otpErr;

    if (!otpEnabled && !userVerified) {
      otpErr = 'Account must be verified & 2FA enabled';
    }
    if (!otpEnabled && userVerified) {
      otpErr = '2FA must be enabled';
    }
    if (otpEnabled && !userVerified) {
      otpErr = 'Account must be verified';
    }
    if (otpEnabled && userVerified) {
      withEnabled = true;
      depEnabled = true;
    }

    const transactionPrivilege = user && user.me && user.me.flags && user.me.flags.transactionPrivilege;
    if (transactionPrivilege) {
      withEnabled = true;
    }

    let balanceSettled;
    if (balance && balance.data && balance.data.length) {
      balanceSettled = balance.data.filter(function (item) {
        return item.type === 'SETTLED';
      });
    }
    let balancePending;
    if (balance && balance.data && balance.data.length) {
      balancePending = balance.data.filter(function (item) {
        return item.type === 'PENDING';
      });
    }
    let balanceAvailable;
    if (balance && balance.data && balance.data.length) {
      balanceAvailable = balance.data.filter(function (item) {
        return item.type === 'AVAILABLE';
      });
    }

    const tradesDisabled = ((user && user.me && user.me.flags && user.me.flags.tradesDisabled) && (user.me.flags.tradesDisabled === true)) && ((user && user.me && user.me.flags && user.me.flags.verified) && (user.me.flags.verified === true));

    if (tradesDisabled) {
      otpEnabled = false;
      // withEnabled = false;
      // depEnabled = false;
    }

    let assetsOrdered;
    if (assets) {
      assetsOrdered = assets && assets.length && assets.slice(0).sort(function (a, b) {
        let aIndex = AssetOrder.indexOf(a.handle);
        let bIndex = AssetOrder.indexOf(b.handle);
        if (aIndex == -1) {
          aIndex = AssetOrder.length + 1;
        }
        if (bIndex == -1) {
          bIndex = AssetOrder.length + 1;
        }
        const sorted = aIndex - bIndex;
        return sorted;
      });
    }

    const assetTableLoop = assetsOrdered && assetsOrdered.length && assetsOrdered.map((value, index) => {
      let handle;
      let humHandle;
      let urlAsset;
      let assetConf;
      let description;
      if (value.handle) {
        handle = value.handle;
      }
      if (value.name) {
        humHandle = value.name;
      }
      if (humHandle) {
        urlAsset = humHandle.replace(/\s+/g, '-').toLowerCase();
      }
      if (AssetConfig && AssetConfig.length) {
        assetConf = AssetConfig.find((item) => item.handle === handle.toUpperCase());
      }
      if (assetConf && assetConf.description) {
        description = assetConf.description;
      }
      let assetSettled;
      if (balanceSettled) {
        assetSettled = balanceSettled.find(function (item) {
          return item.handle === handle;
        });
        if (assetSettled && assetSettled.quantity) {
          assetSettled = assetSettled.quantity;
        }
      }
      let assetPending;
      if (balancePending) {
        assetPending = balancePending.find(function (item) {
          return item.handle === handle;
        });
        if (assetPending && assetPending.quantity) {
          assetPending = assetPending.quantity;
        }
      }
      let assetAvailable;
      if (balanceAvailable) {
        assetAvailable = balanceAvailable.find(function (item) {
          return item.handle === handle;
        });
        if (assetAvailable && assetAvailable.quantity) {
          assetAvailable = assetAvailable.quantity;
        }
      }
      // Sum
      let assetNet;
      let decimal = 8;
      // if (value.decimals && (value.decimals > 0)) {
      //   decimal = value.decimals;
      // }
      if (assetAvailable) {
        // if (decimal) {
        //   assetNet = Number(assetAvailable).toFixed(decimal);
        // } else {
        //   assetNet = Number(assetAvailable).toFixed(8);
        // }
        assetNet = Number(assetAvailable).toFixed(decimal);
      }
      let erc20 = false;
      if (assetConf && assetConf.erc20) {
        erc20 = assetConf.erc20;
      }


      if (this.showCrypto(handle)) {
        let sendDefaults;
        let receiveDefaults;
        if (value.defaults && value.defaults.length) {
          sendDefaults = value.defaults.find((item) => item.SEND);
          if (sendDefaults.SEND) {
            sendDefaults = sendDefaults.SEND;
          }
        }
        if (value.defaults && value.defaults.length) {
          receiveDefaults = value.defaults.find((item) => item.RECV);
          if (receiveDefaults.RECV) {
            receiveDefaults = receiveDefaults.RECV;
          }
        }

        let withEnabledImplicit = withEnabled;

        // if (handle === 'VEUR' || handle === 'VGBP') {
        //   withEnabledImplicit = false; // TODO SIMON PUT BACK
        //   depEnabledImplicit = false;
        // }

        return (
          <TableAsset
            key={index}
            useKey={index + handle}
            handle={handle}
            humHandle={humHandle}
            urlAsset={urlAsset}
            description={description}
            toggleModal={this.toggleModal}
            assetPending={assetPending}
            assetSettled={assetSettled}
            assetNet={assetNet}
            decimal={decimal}
            withEnabled={withEnabledImplicit}
            depEnabled={depEnabled}
            otpEnabled={otpEnabled}
            otpErr={otpErr}
            userVerified={userVerified}
            sendDefaults={sendDefaults}
            receiveDefaults={receiveDefaults}
            assetConf={assetConf}
            erc20={erc20}
          />
        );
      }
      return (null);
    });

    const approvalTableLoop = approvals && approvals.length && approvals.map((item, index) => {
      let asset;
      let quantity;
      let address;
      let createdAt;
      let referenceId;

      if (item) {
        if (item.asset) {
          asset = item.asset;
        }
        if (item.quantity) {
          quantity = item.quantity;
        }
        if (item.address) {
          address = item.address;
        }
        if (item.createdAt) {
          createdAt = moment(item.createdAt).format(dateFormat);
        }
        if (item.referenceId) {
          referenceId = item.referenceId;
        }
      }

      return (
        <tr key={index + asset}>
          <td style={{ textAlign: 'left' }}>
            {asset}
          </td>
          <td>
            {quantity}
          </td>
          <td style={{textTransform: 'initial'}}>
            <span className={tempAnon ? 'eyeblur' : ''}>
              {address}
            </span>
          </td>
          <td className="hide-mob">{createdAt}</td>
        </tr>
      );
    });

    if (assetTableLoop) {
      return (
        <div className="grid-x grid-margin-x" id="transferIndex">
          <ToastHandler errors={errors} />
          {this.state.modalComponent &&
            <Modal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} sideBar={sideBar} darkModal={darkModal} />
          }

          {tradesDisabled && (
            <div className="cell small-12 medium-12 large-12">
              <div className="status alert">
                <span>
                  Withdrawals & Deposits are temporarily disabled.
                  <br />
                </span>
                Due to increased KYC/due diligence requirements, Withdrawals & Deposits have been temporarily disabled. Please contact support for more info, or check back later.
              </div>
            </div>
          )}

          {approvalTableLoop ? (
            <div className="cell panel pend-conf small-12 medium-12 large-12">
              <div className="panel-label">
                Pending Approvals
              </div>
              <p className="mute">Check your email inbox for these confirmation links.</p>
              <div>
                <table className="asset-table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left' }}>Asset</th>
                      <th>Quantity</th>
                      <th>Address</th>
                      <th className="hide-mob">Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvalTableLoop}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null }

          <div className="cell small-12 medium-12 large-12">
            <table className="asset-table at-d">
              <thead>
                <tr>
                  <th>Asset</th>
                  <th>Balance</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {assetTableLoop}
              </tbody>
            </table>
            <table className="asset-table at-m">
              <thead>
                <tr>
                  <th>Asset/Balance</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {assetTableLoop}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return (
      <div className="center-loader">
        <Loader logo />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  balance: state.balance.balance,
  errors: state.balance.errors,
  assets: state.assets.assets,
  tempAnon: state.user.tempAnon,
  approvals: state.coins.approvals,
});

export default connect(mapStateToProps)(Wallets);
